// 블로그 YouTube 영상의 단일 소스. locale 데이터(blog-data.ko/en)와
// 블로그 외 다른 화면에서 동일한 영상을 참조할 때 이 상수를 사용한다.

// 블로그 YouTube 영상 ID. locale별 영상이 따로 있으며 key 는 BlogVideo.key 와 동일.
// 각 가이드 MDX(guide-*.{ko,en}.mdx)의 <YouTube url> 과 같은 영상을 가리켜야 한다.
export const BLOG_VIDEO_YOUTUBE_IDS = {
  ko: {
    product: 'w3OcbjiiEMk',
    detail: 'JdMXgeqoQO4',
    banner: 'r77C45PUoVQ',
    video: '3w8m5h_cHRw',
    'ai-studio': 'G13qKM8Pkf8',
  },
  en: {
    product: 'XbRfBRQq3cU',
    detail: 'f84epW4sfDg',
    banner: 'kfgNErsdOvk',
    video: 'ftYdtC75_QQ',
    'ai-studio': 'HL4q9GQ_HlQ',
  },
} as const;

// YouTube URL(youtu.be, youtube.com/watch, /embed)에서 영상 ID를 추출한다.
const YOUTUBE_ID_RE =
  /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/))([\w-]+)/;

export function parseYouTubeId(url: string): string | null {
  return url.match(YOUTUBE_ID_RE)?.[1] ?? null;
}
